import { addDays, differenceInDays } from 'date-fns';
import { toZonedTime, fromZonedTime } from 'date-fns-tz';
import { timeZone } from 'src/utils/date-time-format';

// by getting the prev day as UTC,
// then converting to CET and set the hour and
// then converting back to UTC the summertime is correctly used
// eslint-disable-next-line prisma-rule/safe-date-now
export function getPreviousGasDay(now = Date.now()) {
  const oneDay = 1000 * 60 * 60 * 24; // 1000 ms * 60 sec * 60 min * 24 hours
  const prevDayUTC = now - oneDay;

  const prevDayCET = toZonedTime(prevDayUTC, timeZone);
  prevDayCET.setHours(6);
  prevDayCET.setMinutes(0);
  prevDayCET.setSeconds(0);
  prevDayCET.setMilliseconds(0);

  const prevGasDayUTC = fromZonedTime(prevDayCET, timeZone);
  return prevGasDayUTC.toISOString();
}

// by getting the prev day as UTC,
// then converting to CET and set the hour and
// then converting back to UTC the summertime is correctly used
export function getNextGasDayDate(now: number) {
  const oneDay = 1000 * 60 * 60 * 24; // 1000 ms * 60 sec * 60 min * 24 hours
  const nextDayUTC = now + oneDay;

  const nextDayCET = toZonedTime(nextDayUTC, timeZone);
  nextDayCET.setHours(6);
  nextDayCET.setMinutes(0);
  nextDayCET.setSeconds(0);
  nextDayCET.setMilliseconds(0);

  return fromZonedTime(nextDayCET, timeZone);
}

export function getCurrentGasDayDate(now: number) {
  // convert now time in UTC to CET
  let nowCET = toZonedTime(now, timeZone);

  // if it is before 06:00 the gas day started "yesterday"
  if (nowCET.getHours() < 6) {
    nowCET = addDays(nowCET, -1);
  }

  nowCET.setHours(6);
  nowCET.setMinutes(0);
  nowCET.setSeconds(0);
  nowCET.setMilliseconds(0);

  // convert back to UTC
  return fromZonedTime(nowCET, timeZone);
}

export function isGasDay(utcDate: string | null) {
  if (utcDate === null || utcDate === '') return false;

  const cetDate = toZonedTime(utcDate, timeZone);
  return (
    cetDate.getHours() === 6 &&
    cetDate.getMinutes() === 0 &&
    cetDate.getSeconds() === 0 &&
    cetDate.getMilliseconds() === 0
  );
}

export function isGasMonth(utcDate: string | null) {
  if (utcDate === null || utcDate === '') return false;

  const cetDate = toZonedTime(utcDate, timeZone);
  return (
    cetDate.getDate() === 1 &&
    cetDate.getHours() === 6 &&
    cetDate.getMinutes() === 0 &&
    cetDate.getSeconds() === 0 &&
    cetDate.getMilliseconds() === 0
  );
}

export function isSingleGasMonth(
  utcDateStart: string | null,
  utcDateEnd: string | null
) {
  if (!isGasMonth(utcDateStart) || !isGasMonth(utcDateEnd)) return false;
  const diff = differenceInDays(new Date(utcDateEnd!), new Date(utcDateStart!));
  return diff >= 28 && diff <= 31;
}

export function getNextGasMonth(utcDate: Date) {
  const cetNextMonth = toZonedTime(utcDate, timeZone);
  // if it is before 0600 on the first of the month, begin of next gas month is same day at 0600, not a month later
  if (!(cetNextMonth.getDate() === 1 && cetNextMonth.getHours() < 6)) {
    const month = cetNextMonth.getMonth();
    cetNextMonth.setDate(1);
    cetNextMonth.setMonth(month === 11 ? 0 : month + 1);
    if (month === 11) {
      // we need to not only set the next month as January, but also increase year by one
      cetNextMonth.setFullYear(cetNextMonth.getFullYear() + 1);
    }
  }
  cetNextMonth.setHours(6);
  cetNextMonth.setMinutes(0);
  cetNextMonth.setSeconds(0);
  cetNextMonth.setMilliseconds(0);

  const utcNextGasMonth = fromZonedTime(cetNextMonth, timeZone);
  return utcNextGasMonth;
}
